import React from 'react';
import { useRouter } from 'next/router';
import { c as classnames } from './index-2586sEvh.js';
import get from 'lodash/get';
import { logImgLoadErrorToRelic } from './utils/logToRelic.js';

const CategorySEO = ({ category, categorySEOOverride }) => {
    if (categorySEOOverride) {
        return categorySEOOverride;
    }
    const { asPath } = useRouter();
    const seoCopy = category.seo_copy || [];
    const imgWidth = category.seo_copy_image_width || null;
    const imgHeight = category.seo_copy_image_height || null;
    const title = get(seoCopy, [0, 'value'], '');
    const imgAltText = title === null || title === void 0 ? void 0 : title.replace(/<[^>]*>?/gm, '');
    const description = get(seoCopy, [1, 'value'], '');
    const imgUrl = get(seoCopy, [2, 'value'], '');
    const getBlockTypeClassName = () => {
        if (!imgUrl)
            return 'only-text';
        if (!title && !description)
            return 'only-image';
        return '';
    };
    if (!title && !description && !imgUrl)
        return null;
    return (React.createElement("div", { id: "category-footer", className: classnames('ctg-seo', getBlockTypeClassName()) },
        React.createElement("div", { className: "ctg-stack-wrap" },
            React.createElement("div", { className: "stack" },
                React.createElement("h2", { "data-gsap": "fade", dangerouslySetInnerHTML: { __html: title } }),
                description && React.createElement("p", { className: "description" }, description))),
        imgUrl && (React.createElement("div", { className: "ctg-img-wrap", "data-gsap": "fade" },
            React.createElement("img", { src: imgUrl, alt: imgAltText, width: imgWidth, height: imgHeight, loading: "lazy", onError: () => logImgLoadErrorToRelic(asPath, imgUrl) })))));
};

export { CategorySEO as C };
//# sourceMappingURL=CategorySEO-5I-hA5gp.js.map
